import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'element', 'wall' ];

    connect() {
        const cookies = document.cookie
        .split("; ")
        .find((row) => row.startsWith("si-cookie-settings="))
        ?.split("=")[1];

        if(cookies == 'full') {
            this.elementTargets.forEach((element) => {
				const dataSrc = element.getAttribute('data-src');
				element.setAttribute('src', dataSrc);
			});

            this.wallTarget.classList.add('hidden');
        }
    }
}